import {Col, Form, Modal, Row} from "react-bootstrap";
import Dropdown from "react-dropdown";
import {Button} from "primereact/button";
import React, {useEffect, useRef, useState} from "react";
import {ReportScheduleService} from "./ReportScheduleService";
import {Toast} from "primereact/toast";

const CreateSchedule = (props) => {

    let userId = JSON.parse(localStorage.getItem("user")).id;


    const [currentReport, setCurrentReport] = useState();

    const toast = useRef(null);
    let reportId = props?.reportId;
    const days =
        ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
    const numberDays = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23",
        "24", "25", "26", "27", "28", "29", "30", "Last Day Of Month"]
    const reportScheduleService = new ReportScheduleService();
    const [createSchedule, setCreateSchedule] = useState({
        cronJob: {
            cronTimeType: null,
            timeFormat: null,
            dayOfWeek: null,
            dayOfMonth: null
        },
        userId: userId,
        reportId: reportId,
        active: true

    });

    const [createShow, setCreateShow] = useState(props?.visible);
    const handleCreateClose = () => {
        setCreateSchedule({...createSchedule, enable: false, cronJob: {cronTimeType: null}});

        props.unVisible();


    }
    const handleCreateShow = () => {
        setTimeout(() => {
            setCreateShow(true);
        }, 200)
    }

    useEffect(() => {

        getReportById();
    }, [props.visible]);

    const getReportById = () => {
        if (reportId) {
            reportScheduleService.getReportById(reportId).then(res => {
                setCurrentReport(res)

            }).catch()
        }


    }


    const handleError = (err) => {

        return toast.current.show({
            severity: 'error',
            summary: "Required field cannot empty"

        })

    };
    return (
        <>
            <Toast ref={toast}/>
            <Modal centered size="lg" show={props.visible} onHide={handleCreateClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Create Scheduler</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>


                        <Form.Group as={Row} className="mb-5" controlId="reportName">

                            <Form.Label column sm={4}>
                                Report Name
                            </Form.Label>
                            <Col sm={6}>
                                <div>
                                    <Dropdown
                                        disabled
                                        value={currentReport?.name}
                                        placeholder="Select Report Name" options={["12"]}/>

                                </div>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-4" controlId="formHorizontalEnable">
                            <Form.Label column sm={4}>
                                Active
                            </Form.Label>
                            <Col sm={8}>
                                <Form.Check required style={{paddingTop: 7}}
                                            name="formHorizontalEnable"
                                            onChange={e => {
                                                let _createSchedule = {...createSchedule};
                                                _createSchedule.active = e.target.checked;
                                                setCreateSchedule(_createSchedule)

                                            }}
                                            checked={createSchedule.active}

                                            type="checkbox" placeholder="Enable"/>
                            </Col>
                        </Form.Group>


                        <fieldset>
                            <Form.Group as={Row} className="mb-4">
                                <Form.Label as="legend" column sm={4}>
                                    Recurrence
                                </Form.Label>
                                <Col sm={8}>
                                    <Form.Check
                                        type="radio"
                                        label="Montly"
                                        name="formHorizontalRadios"
                                        id="formHorizontalRadios1"
                                        onClick={e => {
                                            let _createSchedule = {...createSchedule};
                                            _createSchedule.cronJob.cronTimeType = "MONTLY";
                                            setCreateSchedule(_createSchedule)
                                        }}
                                    />
                                    <Form.Check
                                        type="radio"
                                        label="Weekly"
                                        name="formHorizontalRadios"
                                        id="formHorizontalRadios2"
                                        onClick={e => {
                                            let _createSchedule = {...createSchedule};
                                            _createSchedule.cronJob.cronTimeType = "WEEKLY";
                                            setCreateSchedule(_createSchedule)
                                        }}
                                    />
                                    <Form.Check
                                        type="radio"
                                        label="Daily"
                                        name="formHorizontalRadios"
                                        id="formHorizontalRadios3"
                                        onClick={e => {
                                            let _createSchedule = {...createSchedule};
                                            _createSchedule.cronJob.cronTimeType = "DAILY";
                                            setCreateSchedule(_createSchedule)
                                        }}
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-4" controlId="formHorizontalCheck">


                                <Col sm={{span: 6, offset: 4}}>
                                    {createSchedule?.cronJob?.cronTimeType === "WEEKLY" ?

                                        <Dropdown options={days}
                                                  onChange={e => {
                                                      let _createSchedule = {...createSchedule}
                                                      _createSchedule.cronJob.dayOfMonth = null;
                                                      _createSchedule.cronJob.dayOfMonthLabel = null;
                                                      _createSchedule.cronJob.dayOfWeek = e.value
                                                      setCreateSchedule(_createSchedule)
                                                  }}
                                                  value={createSchedule.cronJob?.dayOfWeek}
                                                  placeholder="Select a day"/>


                                        : createSchedule?.cronJob?.cronTimeType === "MONTLY" ?
                                            <div>
                                                <Dropdown options={numberDays}
                                                          onChange={e => {
                                                              let _createSchedule = {...createSchedule}
                                                              _createSchedule.cronJob.dayOfWeek = null;
                                                              if (e.value === "Last Day Of Month") {
                                                                  _createSchedule.cronJob.dayOfMonth = 0;
                                                                  _createSchedule.cronJob.dayOfMonthLabel = "Last Day Of Month";
                                                              } else {
                                                                  _createSchedule.cronJob.dayOfMonth = parseInt(e.value)
                                                                  _createSchedule.cronJob.dayOfMonthLabel = e.value

                                                              }
                                                              setCreateSchedule(_createSchedule)
                                                          }}
                                                          value={createSchedule?.cronJob?.dayOfMonthLabel}
                                                />
                                            </div>

                                            : ""}
                                </Col>
                            </Form.Group>
                        </fieldset>

                        <Form.Group as={Row} className="mb-4" controlId="formHorizontalCheck">
                            <Form.Label>
                                <Col sm={{span: 4, offset: 0}}>
                                    Time</Col>
                            </Form.Label>
                            <Col sm={{span: 8, offset: 3}}>
                                <input value={createSchedule?.cronJob?.timeFormat} type="time" onChange={e => {
                                    let _createSchedule = {...createSchedule};
                                    _createSchedule.cronJob.timeFormat = e.target.value;
                                    setCreateSchedule(_createSchedule)
                                }}/>
                            </Col>
                        </Form.Group>


                    </Form>

                </Modal.Body>
                <Modal.Footer>
                    <Button style={{backgroundColor: "#0069d9", width: "100px", height: "40px"}} label="Save"
                            className="p-button-raised p-button-primary" onClick={e => {
                        let _createSchedule = {...createSchedule};
                        _createSchedule.reportId = reportId;
                        setCreateSchedule(_createSchedule)
                        reportScheduleService.createReportSchedule(_createSchedule).then(res => {
                            toast.current.show({
                                severity: 'success',
                                summary: 'Successful Transaction',
                                detail: 'Report Schedule Created.'
                            });
                            setCreateSchedule({
                                cronJob: {
                                    cronTimeType: null,
                                    timeFormat: null,
                                    dayOfWeek: null,
                                    dayOfMonth: null
                                },
                                userId: userId,
                                reportId: parseInt(reportId),
                                active: true

                            })
                            props.unVisible();

                        }).catch(err => handleError(err))
                    }}/>
                </Modal.Footer>
            </Modal>
        </>
    )


}
export default CreateSchedule
